import React, { useState, useEffect } from 'react';
import logo  from '../assets/images/starcs.png';
import './Header.css';

const Header = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        window.addEventListener("resize", () => {
            setIsMobile(window.innerWidth <= 768);
        });
    }, []);

    const headerStyle = {
        backgroundColor: '#f3f3f3',
        minHeight: '10vh',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: 'calc(10px + 2vmin)',
        color: 'white',
        padding: '0 20px',

        logo: {
            height:  '100px',
        }
    };

    const navStyle = {
        display: isMobile ? (menuOpen ? 'flex' : 'none') : 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        listStyle: 'none',
    };

    const navItemStyle = {
        margin: '0 10px',
    };


    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <header style={headerStyle}>
            <img src={logo} alt="STARCS Technologies" style={headerStyle.logo}/>
            {isMobile && <button onClick={toggleMenu} style={{ alignSelf: 'flex-end' }}>☰</button>}
            <nav>
                <ul style={navStyle}>
                    <li style={navItemStyle}><a href="/">Home</a></li>
                    <li style={navItemStyle}><a href="/courses">Courses</a></li>
                    <li style={navItemStyle}><a href="/about">About</a></li>
                    <li style={navItemStyle}><a href="/contact">Contact</a></li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;